'use strict';
import React, { PureComponent } from 'react';

class DetalleSuperior extends PureComponent {
    constructor(props) {
        super(props);

        this.state = {
            mostrarComboEstados: false,
            codigoEstado: props.registro ? props.registro.EstadoDescripcion : ""
        }
    }

    mostrarComboEstados() {
        this.setState({mostrarComboEstados: !this.state.mostrarComboEstados});
    }

    seleccionarEstado(estadoDescripcion) {
        let estado = this.props.comboEstadosAsientos.find(
          estado => estado.Descripcion === estadoDescripcion
        );
      
        if (estado) {
          this.props.cambiarEstadoAsiento(estado.Id, estado.Descripcion, "modalAsientosContables");
        }
          this.setState({
            mostrarComboEstados: !this.state.mostrarComboEstados,
          });
      }
      
    formatearFecha(fecha) {
      
        var fechaObj = new Date(fecha);
    
        var dia = fechaObj.getDate();
        var mes = fechaObj.getMonth() + 1; // Sumar 1 porque los meses van de 0 a 11
        var año = fechaObj.getFullYear();
    
        dia = (dia < 10) ? '0' + dia : dia;
        mes = (mes < 10) ? '0' + mes : mes;
    
        return dia + '/' + mes + '/' + año;
    }

    getStyleForEstado(estadoDescripcion) {
        switch (estadoDescripcion) {
            case 'Confirmado':
                return 'AsientosContables__SeccionGrillaEstado AsientosContables__SeccionGrillaEstado--Conf';

            case 'Pendiente':
                return 'AsientosContables__SeccionGrillaEstado AsientosContables__SeccionGrillaEstado--Pend';

            case 'Dado de Baja':
                return 'AsientosContables__SeccionGrillaEstado AsientosContables__SeccionGrillaEstado--Dado';

            case 'Enviado':
                return 'AsientosContables__SeccionGrillaEstado AsientosContables__SeccionGrillaEstado--Envi';

            default:
                return '';
        }
    }

    render() {

        const {
            registro,
            comboEstadosAsientos,
            permisosUsuario
        } = this.props;


        let estadoDescripcionAsiento = (registro && registro.EstadoDescripcionCombo) ? registro.EstadoDescripcionCombo : registro.EstadoDescripcion

        if(estadoDescripcionAsiento.toUpperCase().includes("PEND")){
            estadoDescripcionAsiento = "Pendiente"
        }

        if(estadoDescripcionAsiento.toUpperCase().includes("ENVIADO")){
            estadoDescripcionAsiento = "Enviado"
        }

        let textoSucursal = registro && registro.SucursalId != null ? `${registro.SucursalCodigo} - ${registro.SucursalDescripcion}`
                                                            : `${registro.SucursalDescripcion} - ${registro.AperturaSucursal}`;

        let estadosArray = comboEstadosAsientos ? comboEstadosAsientos.map(estado => estado.Descripcion) : null;

        let tienePermisoModificacion = permisosUsuario.Confirmacion;
        let tienePermisoBaja = permisosUsuario.Baja;

        let desactivaCombo = registro && registro.EstadoDescripcion == "Dado de Baja" || registro && registro.EstadoDescripcion == "Enviado al Core"|| !tienePermisoModificacion

        if (tienePermisoModificacion) {
            if (tienePermisoBaja) {
                // Si tiene permisos para modificar y dar de baja, no se filtra
                estadosArray = estadosArray;
            } else {
                // Si solo tiene permisos para modificar, excluimos el estado "Dado de Baja"
                estadosArray = estadosArray.filter(estado => estado !== 'Dado de Baja');
            }
        } else {
            // Si no tiene permisos para modificar, se excluyen todos los estados
            estadosArray = [];
        }

        if(estadosArray){
            estadosArray = estadosArray.filter(estado => estado !== estadoDescripcionAsiento);

            estadosArray = estadosArray.map((estado, index) => (
                <div className="AsientosContables__modalDetalleAsiento__opcionEstadoIndividual" key={index} onClick={() => this.seleccionarEstado(estado)}>
                    <div className={`AsientosContables__modalDetalleAsiento__contenedorEstadoDescripcion ${this.getStyleForEstado(estado)}`}>
                        {estado}
                    </div>
                </div>
            ));
        }
      
        return (
            <div className="AsientosContables--overflowHidden AsientosContables__modalDetalleAsiento__contenedorDetalleSuperior AsientosContables__modalDetalleAsiento__contenedorDetalleSuperiorAsiento">
                <div className="AsientosContables--overflowHidden AsientosContables--floatLeft AsientosContables__modalDetalleAsiento__contenedorDetalleSuperiorIzquierdo">
                    <div className="AsientosContables--floatLeft AsientosContables__modalDetalleAsiento__titulosDetalleIzquierdo">
                        <div>ID asiento:</div>
                        <div className="AsientosContables__modalDetalleAsiento__titulosDetalleAmbos">Modelo:</div>
                        <div className="AsientosContables__modalDetalleAsiento__titulosDetalleAmbos">Moneda de selección:</div>
                        <div className="AsientosContables__modalDetalleAsiento__titulosDetalleAmbos">Indicador de interfaz:</div>
                        <div className="AsientosContables__modalDetalleAsiento__titulosDetalleAmbos">Sucursal:</div>
                        <div className="AsientosContables__modalDetalleAsiento__titulosDetalleAmbos">Apertura por socio:</div>
                    </div>

                    <div className="AsientosContables__modalDetalleAsiento__contenedorDatosDetalleSuperiorIzquierdo">
                        <div className="AsientosContables__modalDetalleAsiento__descripcionesDetalleDerecho">{registro && registro.AsientocabeceraId}</div>
                        <div className="AsientosContables__modalDetalleAsiento__titulosDetalleAmbos AsientosContables__modalDetalleAsiento__descripcionesDetalleDerecho">{registro && registro.ModeloCabeceraId} - {registro && registro.ModeloCabeceraDescripcion}</div>
                        <div className="AsientosContables__modalDetalleAsiento__titulosDetalleAmbos AsientosContables__modalDetalleAsiento__descripcionesDetalleDerecho">{registro && registro.MonedaDescripcion}</div>
                        <div className="AsientosContables__modalDetalleAsiento__titulosDetalleAmbos AsientosContables__modalDetalleAsiento__descripcionesDetalleDerecho">{registro && registro.IndicadorDescripcion}</div>
                        <div className="AsientosContables__modalDetalleAsiento__titulosDetalleAmbos AsientosContables__modalDetalleAsiento__descripcionesDetalleDerecho">{textoSucursal}</div>
                        <div className="AsientosContables__modalDetalleAsiento__titulosDetalleAmbos AsientosContables__modalDetalleAsiento__descripcionesDetalleDerecho">{registro && registro.AperturaCuentaTarjeta}</div>
                    </div>
                </div>

                <div className="AsientosContables--overflowHidden AsientosContables--floatLeft AsientosContables--widthAuto AsientosContables__modalDetalleAsiento__contenedorDetalleSuperiorDerecho">
                    <div className="AsientosContables--floatLeft AsientosContables__modalDetalleAsiento__titulosDetalleIzquierdo">
                        <div>Fecha valor contable:</div>
                        <div className="AsientosContables__modalDetalleAsiento__titulosDetalleAmbos">Fecha contabilización:</div>
                        <div className="AsientosContables__modalDetalleAsiento__titulosDetalleAmbos">Manual:</div>
                        <div className="AsientosContables__modalDetalleAsiento__titulosDetalleAmbos">Confirmación automática:</div>
                        <div className="AsientosContables__modalDetalleAsiento__titulosDetalleAmbos">Estado:</div>
                        <div className="AsientosContables__modalDetalleAsiento__titulosDetalleAmbos">Consolidación:</div>
                    </div>

                    <div className="AsientosContables__modalDetalleAsiento__contenedorDatosDetalleSuperiorDerecho">
                        <div className="AsientosContables__modalDetalleAsiento__descripcionesDetalleDerecho">{registro && this.formatearFecha(registro.FechaValorContable)}</div>
                        <div className="AsientosContables__modalDetalleAsiento__titulosDetalleAmbos AsientosContables__modalDetalleAsiento__descripcionesDetalleDerecho">{registro && this.formatearFecha(registro.FechaContabilizacion)}</div>
                        <div className="AsientosContables__modalDetalleAsiento__titulosDetalleAmbos AsientosContables__modalDetalleAsiento__descripcionesDetalleDerecho">{registro && registro.Manual}</div>
                        <div className="AsientosContables__modalDetalleAsiento__titulosDetalleAmbos AsientosContables__modalDetalleAsiento__descripcionesDetalleDerecho">{registro && registro.ConfirmacionAutomatica}</div>
                        <div className="AsientosContables__modalDetalleAsiento__titulosDetalleAmbos AsientosContables__modalDetalleAsiento__titulosDetalleAmbos--Estado">
                            <div className="AsientosContables__contenedorSelectEstado">
                            <div className={desactivaCombo ?  "AsientosContables__modalDetalleAsiento__comboDesactivado" : "AsientosContables__modalDetalleAsiento__opcionSeleccionada seccionDatosGenerales__inputSelect AsientosContables__modalDetalleAsiento__estadoSelect"} onClick={() => this.mostrarComboEstados()}>
                                    <div className={`AsientosContables--floatLeft AsientosContables__modalDetalleAsiento__contenedorEstadoDescripcion AsientosContables__modalDetalleAsiento__opcionSeleccionada ${this.getStyleForEstado(estadoDescripcionAsiento)}`}>
                                    {estadoDescripcionAsiento}
                                    </div>
                                   
                                   {!desactivaCombo ? <div className="AsientosContables--floatLeft icono-flechaSelect AsientosContables__modalDetalleAsiento__iconoFlechaSelect"></div> : null}     
                                  </div>
                                {this.state.mostrarComboEstados && !desactivaCombo ? 
                                 <div className="AsientosContables__modalDetalleAsiento__contenedorOpcionesEstado">
                                    {estadosArray}
                                 </div>
                                
                                : null }
                            </div>
                        </div>
                        <div className="AsientosContables__modalDetalleAsiento__titulosDetalleAmbos AsientosContables__modalDetalleAsiento__descripcionConsolidacion AsientosContables__modalDetalleAsiento__titulosDetalleAmbos--Consolidacion">{registro && registro.TipoConsolidacion}</div>
                    </div>
                </div>
            </div>
        );
    }
}

export default DetalleSuperior;